import React from 'react';

const getLeadTypeClasses = (type) => {
  if (type === 'casa') return 'bg-blue-100 text-blue-700';
  if (type === 'carro') return 'bg-orange-100 text-orange-700';
  if (type === 'reforma') return 'bg-purple-100 text-purple-700';
  return 'bg-gray-100 text-gray-700';
};

const getLeadTypeLabel = (type, withIcon = false) => {
  if (type === 'casa') return withIcon ? '🏠 Casa' : 'casa';
  if (type === 'carro') return withIcon ? '🚗 Carro' : 'carro';
  if (type === 'reforma') return withIcon ? '🏗️ Reforma' : 'reforma';
  return withIcon ? '💬 Contato' : type;
};

export const LeadTypeBadge = ({ type, withIcon = false, className = '' }) => {
  return (
    <span className={`${getLeadTypeClasses(type)} ${className}`.trim()}>
      {getLeadTypeLabel(type, withIcon)}
    </span>
  );
};